import * as ngCore from '@angular/core'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import { TypeAsserter } from '@attain-apps/type-guards'
import * as rxjs from 'rxjs'

import * as gql from '../gql'
import type { TypeParams } from '../types'

/** Survey admins API. */
@ngCore.Injectable()
export class Api implements ec.models.Api<TypeParams> {
  /** @inheritdoc */
  public list = ec.models.Api.list.using.nothingButContext<TypeParams>(
    context =>
      context ? gql.queries.surveyAdmins.executor(context) : rxjs.of([]),
  )

  /** @inheritdoc */
  public create: ec.models.Api<TypeParams>['create'] = (
    context,
    { userId },
  ) => {
    TypeAsserter.assertIsNotNullish(context)

    return gql.mutations.assignSurveyAdmin.executor({ ...context, userId })
  }

  /** @inheritdoc */
  public delete: ec.models.Api<TypeParams>['delete'] = (context, id) => {
    TypeAsserter.assertIsNotNullish(context)

    return gql.mutations.removeAccessAssignment.executor({ ...context, id })
  }

  /** @inheritdoc */
  public getAttributes: ec.models.Api<TypeParams>['getAttributes'] = () =>
    rxjs.of([
      ec.models.Attribute.fromKey<TypeParams>('userId', { name: 'User Id' }),
      ec.models.Attribute.fromKey<TypeParams>('name', { name: 'Name' }),
    ])
}
